<app-splash-screen />
<app-toast />
<router-outlet></router-outlet>
